<template>
  <section class="row">
    <div class="col-12">
      <div class="card">
        <div
          class="card-body py-md-4 pt-4 rounded-4 transition-shadow
            box-shadow-pink-300 box-shadow-hover-pink-300"
        >
          <div class="row">
            <div class="col-2">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-8">
              <div class="h5 text-center mb-3">
                Personne à contacter
              </div>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <p>
                Vous pouvez indiquer la personne à contacter par notre équipe
                pour tous les sujets concernant la gestion et le suivi de vos contrats d’assurance.
              </p>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <div class="row">
                <div class="col-12 col-md-6">
                  <v-input
                    input-id="lastName"
                    label="Nom"
                    module-name="company"
                    getter-name="get"
                    :getter-function="({ contacts }) => contacts[0].lastName"
                    path="contacts[0].lastName"
                  />
                </div>
                <div class="col-12 col-md-6 mt-3 mt-md-0">
                  <v-input
                    input-id="firstName"
                    label="Prénom"
                    module-name="company"
                    getter-name="get"
                    :getter-function="({ contacts }) => contacts[0].firstName"
                    path="contacts[0].firstName"
                  />
                </div>
                <div class="col-12 my-3">
                  <v-select
                    input-id="position"
                    label="Fonction"
                    module-name="company"
                    getter-name="get"
                    :getter-function="({ contacts }) => contacts[0].position"
                    :list="positions"
                    path="contacts[0].position"
                  />
                </div>
                <div class="col-12">
                  <v-input
                    input-id="email"
                    label="Adresse email"
                    module-name="company"
                    getter-name="get"
                    :getter-function="({ contacts }) => contacts[0].email"
                    path="contacts[0].email"
                  />
                </div>
                <div class="col-12 my-3">
                  <v-loader
                    :next="updateCompany"
                    title="Valider les modifications"
                    class="w-100"
                  />
                </div>
                <div class="col-12">
                  <v-loader
                    :next="undo"
                    title="Annuler"
                    color="block"
                    class="w-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import Input from '@/components/common/input/Input2.vue';
import Select from '@/components/common/input/CustomSelect2.vue';

export default {
  name: 'AccountContact',
  components: {
    'v-input': Input,
    'v-select': Select,
  },
  computed: {
    ...mapGetters({
      positions: 'rater/positions',
      companyId: 'company/companyId',
    }),
  },
  beforeUnmount() {
    this.$store.dispatch('company/setCompanyById', this.companyId);
  },
  methods: {
    async updateCompany() {
      await this.$store.dispatch('company/updateCompany');
      return this.$store.dispatch('ui/showModalAccount', { value: true, type: 'contact' });
    },
    async undo() {
      await this.$store.dispatch('company/setCompanyById', this.companyId);
      return this.$router.push('/client/account');
    },
  },
};
</script>
